// React
import { useContext, useState } from "react"

// Components
import { HeaderMenu } from "components"
import { Format, UploadFile } from "../components"
import { ImportData } from "./components"

// Contexts
import { DataContext, MasterContext, MasterProvider } from "./contexts"

// Types
import type { DataContextType, DataType } from "../types"

// Utils
import { headerBlankExample, headerExample, headerList } from "./utils"

export default function ImportItem(): JSX.Element {
  // Hooks
  const [data, setData] = useState<DataType[]>([])

  return (
    <section className="container my-3 flex flex-col gap-5">
      <HeaderMenu title="IMPORT ITEM" />

      <DataContext.Provider value={{ data, assignData: setData }}>
        <MasterProvider>
          <section className="flex flex-wrap gap-3">
            <Format
              assignData={setData}
              blankExample={headerBlankExample}
              data={data}
              example={headerExample}
              list={headerList}
            />

            <UploadSection
              assignData={setData}
              blankExample={headerBlankExample}
              data={data}
              example={headerExample}
              list={headerList}
            />
          </section>

          {data.length ? <ImportData /> : <></>}
        </MasterProvider>
      </DataContext.Provider>
    </section>
  )
}

function UploadSection(params: DataContextType): JSX.Element {
  // Vars
  const { isError, isLoading } = useContext(MasterContext)

  return (
    <UploadFile
      {...params}
      fetchMasterData={{ isError, isLoading }}
    />
  )
}